import { useCallback, useState } from 'react';

import { DEFAULT_TOAST_DURATION } from './consts';
import { Toast, OpenToast, CloseToast, UpdateToastProgress } from './interfaces';

export const useToastNotification = () => {
  const [toast, setToast] = useState<Toast>({ isOpen: false } as Toast);

  const openToast: OpenToast = initProps => {
    setToast({
      isOpen: true,
      autoHideDuration: DEFAULT_TOAST_DURATION,
      closeOnClickOnly: false,
      ...initProps
    });
  };

  const updateProgress: UpdateToastProgress = useCallback((progress: number) => {
    setToast(prevState => ({ ...prevState, progress }));
  }, []);

  const closeToast: CloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setToast(prevState => ({ ...prevState, isOpen: false, progress: undefined }));
  };

  return { toast, closeToast, openToast, updateProgress };
};

